import de from './de/translations.json';
import en from './en/translations.json';
import es from './es/translations.json';
import fr from './fr/translations.json';
import it from './it/translations.json';
import pt from './pt/translations.json';
export default {
  de,
  en,
  es,
  fr,
  it,
  pt,
};
